import VMasker from 'vanilla-masker';
import LazyLoad from "vanilla-lazyload";
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default.js';
import Splide from '@splidejs/splide';

require('bootstrap/js/dist/modal');

// variables
const ismobile = window.innerWidth <= 768;
const isdesktop = window.innerWidth >= 768;
const pageLazyLoad = new LazyLoad();

// document load
document.addEventListener("DOMContentLoaded", () => {

    // Toggle Menu Button
    on('.js-menu-toggle', 'click', () => {
        document.body.classList.toggle('menu-active');
    })

    // Close popup
    on('.js-close-popup', 'click', (e) => {
        document.querySelector('.popup-wrapper').style.display = 'none';
    });


    // Modal Contato
    on('.js-open-modal', 'click', (e) => {
        let tipo = e.currentTarget.getAttribute('data-modal-target');
        document.querySelector(`[data-modal-contato=${tipo}]`).classList.add('active');
        e.preventDefault();
    })
    on('.js-close-modal', 'click', (e) => {
        e.currentTarget.closest('.modal-contato').classList.remove('active');
        e.preventDefault();
    })


    // Tipo Contato
    on('.js-select-contato', 'change', (e) => {
        let select = e.currentTarget,
            form = select.closest('form'),
            required = select.options[select.selectedIndex].hasAttribute('data-tel-required');

        if (required) {
            form.telefone.required = true;
            form.telefone.parentElement.querySelector('label span').style.display = 'none';
        } else {
            form.telefone.required = false;
            form.telefone.parentElement.querySelector('label span').removeAttribute('style');
        }

        if (form.telefone.classList.contains('is-valid') || form.telefone.classList.contains('is-invalid')) {
            let event = new Event('blur');
            form.telefone.dispatchEvent(event);
        }

    })


    // Validacao Form
    on('form[data-hubid-form]', 'submit', (e) => {
        e.preventDefault();
        let form = e.currentTarget;

        if (!form.checkValidity()) {
            form.classList.add('was-validated');
            return;
        }

        window.__hubidLastForm = form;
    })
    on('.form-control, .form-select', 'blur', (e) => {
        let input = e.currentTarget,
            class_add = input.checkValidity() ? 'is-valid' : 'is-invalid',
            class_remove = input.checkValidity() ? 'is-invalid' : 'is-valid';

        input.classList.remove(class_remove);
        input.classList.add(class_add);
    })


    // Mascara Telefone
    masked.tel('input[data-mask=tel]');


    // Carrossel
    document.querySelectorAll('.splide-images').forEach(el => {
        new Splide(el, {
            lazyLoad: true,
            focus: 'center',
            perPage: 1,
            fixedWidth: 640,
            trimSpace: false,
            updateOnMove: true,
            pagination: false,
            arrows: true,
            classes: {
                prev: 'splide__arrow--prev icon-prev',
                next: 'splide__arrow--next icon-next'
            },
            breakpoints: {
                640: {
                    perPage: 1,
                    padding: {
                        right: '5%',
                        left: 20
                    },
                    fixedWidth: false,
                    gap: 0,
                    arrows: false,
                    pagination: true
                }
            }
        }).mount();
    });

    if (ismobile) {
        document.querySelectorAll('.splide-proximidade').forEach(el => {
            new Splide(el, {
                lazyLoad: true,
                perPage: 1,
                gap: 15,
                trimSpace: false,
                updateOnMove: true,
                pagination: true,
                arrows: false,
                autoHeight: true,
                classes: {
                    prev: 'splide__arrow--prev icon-prev',
                    next: 'splide__arrow--next icon-next'
                }
            }).mount();
        });
    }

    if (ismobile) {
        document.querySelectorAll('.splide-projeto').forEach(el => {
            new Splide(el, {
                lazyLoad: true,
                focus: 'center',
                perPage: 1,
                gap: 15,
                trimSpace: false,
                updateOnMove: true,
                pagination: true,
                arrows: false,
                classes: {
                    prev: 'splide__arrow--prev icon-prev',
                    next: 'splide__arrow--next icon-next'
                }
            }).mount();
        });
    }


    // Abas
    document.querySelectorAll('[data-tab]').forEach(el => {
        el.querySelectorAll('[data-tab-index="0"]').forEach(el => el.classList.add('active'));

        on('.tab-btn', el, 'click', (e) => {
            let index = e.currentTarget.getAttribute('data-tab-index');
            el.querySelectorAll('[data-tab-index').forEach(el => el.classList.remove('active'));
            el.querySelectorAll(`[data-tab-index="${index}"]`).forEach(el => el.classList.add('active'));
        })

    })


    // Parallax
    document.querySelectorAll('.js-parallax').forEach(el => {
        let parallaxImg = () => {
            let speed = parseFloat(el.getAttribute('data-speed')) + 1;
            let winY = window.scrollY;
            if (winY > el.clientHeight) return;

            el.style.transform = 'translate3d(0,' + (winY / speed) + 'px, 0)'
        }

        document.addEventListener('scroll', parallaxImg);
        parallaxImg();
    })


    // Zoom Images
    on('.js-zoom', 'click', (e) => {
        zoomPhotoswipe(e.currentTarget);
        e.preventDefault();
    });


    // Button Play
    on('.js-play', 'click', (e) => {
        const iframe = e.currentTarget.nextElementSibling;
        iframe.setAttribute('src', iframe.getAttribute('data-src'));
        e.currentTarget.classList.add('hide');
    })

    // on('.btn-tour', 'click', (e) => {     
    //     e.preventDefault();
    //     let imagem = document.getElementById('bg-tour')   
    //     const iframe = e.currentTarget.nextElementSibling;
    //     iframe.setAttribute('src', iframe.getAttribute('data-src'));
    //     imagem.classList.add('active');
    // })


    // Scroll To
    on('.menu-link, .js-scrollto', 'click', (e) => {
        e.preventDefault();
        const href = e.currentTarget.getAttribute('href');
        const pos = offset(document.querySelector(href)).top;

        scroll({
            top: pos,
            behavior: 'smooth'
        });
    });

})

/*
 * name: on
 * description: 
 */
const on = (...args) => {
    let selector = args[0],
        element = args.length == 4 ? args[1] : document,
        handler = args.pop(),
        event = args.pop();

    element.querySelectorAll(selector).forEach((target) => {
        target.addEventListener(event, handler)
    });
};

/*
 * name: offset
 * description: 
 */
const offset = (el) => {
    const rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return {
        top: rect.top + scrollTop,
        left: rect.left + scrollLeft
    }
}


/*
 * name: zoomPhotoswipe
 * description: 
 */
const zoomPhotoswipe = (el) => {

    let
        grupo = el.getAttribute('data-zoom-group'),
        items = new Array(),
        index = parseInt(el.getAttribute('data-zoom-index'));

    document.querySelectorAll('[data-zoom-group="' + grupo + '"]').forEach((el) => {
        let size = el.getAttribute('data-zoom-size').split('x');

        let item = {
            src: el.getAttribute('href'),
            w: size[0],
            h: size[1],
            title: el.nextElementSibling.textContent
        }

        items.push(item);
    })

    if (document.querySelectorAll('.pswp').length == 0) insertModalPS();

    let pswpElement = document.querySelector('.pswp');

    let options = {
        index: index,
        closeOnScroll: false,
        loop: false,
        fullscreenEl: false,
        shareEl: false,
        arrowEl: !ismobile,
        errorMsg: '<div class="pswp__error-msg">Imagem não encontrada. <a href="%url%" target="_blank">Clique aqui</a> para abrir em uma nova aba.</div>'
    };

    let gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();
}

/*
 * name: insertModalPS
 * description: 
 */
const insertModalPS = () => {
    let html = `<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="pswp__bg"></div>
        <div class="pswp__scroll-wrap">
            <div class="pswp__container">
                <div class="pswp__item"></div>
                <div class="pswp__item"></div>
                <div class="pswp__item"></div>
            </div>
            <div class="pswp__ui pswp__ui--hidden">
                <div class="pswp__top-bar">
                    <div class="pswp__counter"></div>
                    <button class="pswp__button pswp__button--close" title="Fechar (Esc)"></button>
                    <button class="pswp__button pswp__button--share" title="Compartilhar"></button>
                    <button class="pswp__button pswp__button--fs" title="Fullscreen"></button>
                    <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>
                    <div class="pswp__preloader">
                        <div class="pswp__preloader__icn">
                        <div class="pswp__preloader__cut">
                            <div class="pswp__preloader__donut"></div>
                        </div>
                        </div>
                    </div>
                </div>
                <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
                    <div class="pswp__share-tooltip"></div> 
                </div>
                <button class="pswp__button pswp__button--arrow--left" title="Voltar"></button>
                <button class="pswp__button pswp__button--arrow--right" title="Avançar"></button>
                <div class="pswp__caption">
                    <div class="pswp__caption__center"></div>
                </div>
            </div>
        </div>
    </div>`;

    document.body.insertAdjacentHTML('beforeend', html);
}

/*
 * name: masked
 * description: 
 */
const masked = {
    tel: (selector) => {
        const telMask = ['(99) 9999-99999', '(99) 99999-9999'];
        document.querySelectorAll(selector).forEach((el) => {
            VMasker(el).maskPattern(telMask[0]);
            el.addEventListener('input', masked.handler.bind(undefined, telMask, 14), false);
        });
    },
    handler: (masks, max, event) => {
        const c = event.target;
        const v = c.value.replace(/\D/g, '');
        const m = c.value.length > max ? 1 : 0;
        VMasker(c).unMask();
        VMasker(c).maskPattern(masks[m]);
        c.value = VMasker.toPattern(v, masks[m]);
    }
}

/*
 * name: gaEvent
 * description: 
 */
window.ga_event = (category, action, label) => {
    try {
        gtag('event', action, {
            event_category: category,
            event_label: label
        });
    } catch (e) {
        console.warn('GA não instalado.')
    }
}

/*
 * name: Hubid
 * description: 
 */
window.hubid_callback = (state, form, channel, message) => {
    let tipo = form.getAttribute('data-tipo');

    if (state === 'success') {
        ga_event('Contato', 'Sucesso ' + tipo);

        if (typeof fbq == 'function') fbq('track', 'Lead');
    }
}

// magnify hover (Lupa)
if (isdesktop) {
    function magnify(imgID, zoom) {
        var img, glass, w, h, bw;
        img = document.getElementById(imgID);
        /*create magnifier glass:*/
        glass = document.createElement("div");
        glass.setAttribute("class", "img-magnifier-glass");
        /*insert magnifier glass:*/
        img.parentElement.insertBefore(glass, img);
        /*set background properties for the magnifier glass:*/
        glass.style.backgroundImage = "url('" + img.src + "')";
        glass.style.backgroundRepeat = "no-repeat";
        glass.style.backgroundSize = (img.width * zoom) + "px " + (img.height * zoom) + "px";
        bw = 3;
        w = glass.offsetWidth / 2;
        h = glass.offsetHeight / 2;
        /*execute a function when someone moves the magnifier glass over the image:*/
        glass.addEventListener("mousemove", moveMagnifier);
        img.addEventListener("mousemove", moveMagnifier);
        /*and also for touch screens:*/
        glass.addEventListener("touchmove", moveMagnifier);
        img.addEventListener("touchmove", moveMagnifier);

        function moveMagnifier(e) {
            var pos, x, y;
            /*prevent any other actions that may occur when moving over the image*/
            e.preventDefault();
            /*get the cursor's x and y positions:*/
            pos = getCursorPos(e);
            x = pos.x;
            y = pos.y;
            /*prevent the magnifier glass from being positioned outside the image:*/
            if (x > img.width - (w / zoom)) {
                x = img.width - (w / zoom);
            }
            if (x < w / zoom) {
                x = w / zoom;
            }
            if (y > img.height - (h / zoom)) {
                y = img.height - (h / zoom);
            }
            if (y < h / zoom) {
                y = h / zoom;
            }
            /*set the position of the magnifier glass:*/
            glass.style.left = (x - w) + "px";
            glass.style.top = (y - h) + "px";
            /*display what the magnifier glass "sees":*/
            glass.style.backgroundPosition = "-" + ((x * zoom) - w + bw) + "px -" + ((y * zoom) - h + bw) + "px";
        }

        function getCursorPos(e) {
            var a, x = 0,
                y = 0;
            e = e || window.event;
            /*get the x and y positions of the image:*/
            a = img.getBoundingClientRect();
            /*calculate the cursor's x and y coordinates, relative to the image:*/
            x = e.pageX - a.left;
            y = e.pageY - a.top;
            /*consider any page scrolling:*/
            x = x - window.pageXOffset;
            y = y - window.pageYOffset;
            return {
                x: x,
                y: y
            };
        }
    }
    /* Initiate Magnify Function
    with the id of the image, and the strength of the magnifier glass:*/
    magnify("mag", 3);
    magnify("mag2", 3);
}